import React, { useState, useEffect, useRef } from 'react'
import { Form } from 'react-final-form'
import { Button } from '../../atoms/Button'
import axios from 'axios'
import { useHistory } from 'react-router-dom'
import { FORM_ERROR } from 'final-form'
import { useAuth } from '../../molecules/Auth'
import ErrorValidationMessage from '../../molecules/ErrorValidationMessage'
import PublicFooter from '../../organisms/footer/PublicFooter'
import SupportMessage from '../../molecules/SupportMessage'
import OtpInput from '../../molecules/fields/OtpInput'
import { QRCodeCanvas } from 'qrcode.react'

const verify2faMutation = values => axios.post('/admin/v1/two_factor_auth/verify.json', values)
const setup2faMutation = values => axios.post('/admin/v1/two_factor_auth.json', values)

const TwoFactorVerify = () => {
  const history = useHistory()
  const { user, getUser, logout } = useAuth()

  const [code, setCode] = useState('')
  const [code1, setCode1] = useState('')
  const [code2, setCode2] = useState('')
  const code2Ref = useRef(null)

  const isSetup = user?.otp_enabled && !user?.otp_secret_configured
  const setupData = user?.pending_2fa_setup

  useEffect(() => {
    if (user && !user.needs_2fa_verification) {
      history.replace('/formularios')
    }
  }, [user])

  const handleSubmit = async () => {
    try {
      let response
      if (isSetup && setupData) {
        response = await setup2faMutation({
          secret: setupData.otp_secret,
          code1,
          code2
        })
      } else {
        response = await verify2faMutation({ code })
      }

      await getUser()

      const nextStep = response.data?.next_step
      if (nextStep === 'verify_email') {
        history.push('/verificar-correo')
      } else if (nextStep === 'change_password') {
        history.push('/cambiar-contrasena')
      } else {
        history.push('/formularios')
        localStorage.setItem('showFormStartMessage', 'true')
      }
    } catch (error) {
      return { [FORM_ERROR]: error.response?.data?.error || 'Ocurrió un error inesperado' }
    }
  }

  const handleCancel = () => {
    logout().then(() => {
      history.push('/')
    })
  }

  if (!user?.needs_2fa_verification) return null

  const showSetup = isSetup && setupData

  return (
    <>
      <div className="flex-1 md:flex items-center justify-center">
        <div className="px-6 pt-8 md:py-16 md:flex items-center justify-center w-full max-w-lg">
          <div className="m-auto w-full">
            <Form onSubmit={handleSubmit}>
              {({ handleSubmit, submitError, submitting }) => (
                <form
                  onSubmit={handleSubmit}
                  className="bg-white p-6 lg:p-10 shadow-card-login items-center justify-center"
                >
                  <h2 className="font-bold text-xl mb-6">
                    {showSetup ? 'Configura la autenticación de dos pasos' : 'Verificación de dos pasos'}
                  </h2>

                  {!showSetup && (
                    <>
                      <p className="mb-4 text-sm">Ingresa el código de 6 dígitos de tu aplicación de autenticación.</p>
                      <div className="flex justify-center mb-6">
                        <OtpInput value={code} onChange={setCode} disabled={submitting} />
                      </div>
                    </>
                  )}

                  {showSetup && (
                    <>
                      <div className="mb-6 flex justify-center">
                        {setupData?.provisioning_uri && <QRCodeCanvas value={setupData.provisioning_uri} size={150} />}
                      </div>
                      <p className="text-sm mb-4">
                        Escanea el código QR con tu aplicación de autenticación (Google Authenticator, Authy, etc).
                      </p>
                      <p className="font-bold text-sm mb-2">Paso 1: Ingresa el código actual</p>
                      <div className="flex justify-center mb-4">
                        <OtpInput
                          value={code1}
                          onChange={setCode1}
                          disabled={submitting}
                          onComplete={() => {
                            if (code2Ref.current) {
                              const firstInput = code2Ref.current.querySelector('input')
                              if (firstInput) firstInput.focus()
                            }
                          }}
                        />
                      </div>
                      <p className="font-bold text-sm mb-2">Paso 2: Espera e ingresa el siguiente código</p>
                      <div className="flex justify-center mb-6">
                        <div ref={code2Ref}>
                          <OtpInput value={code2} onChange={setCode2} disabled={submitting} focusOnMount={false} />
                        </div>
                      </div>
                    </>
                  )}

                  {submitError && <ErrorValidationMessage className="max-w-fit mb-6" error={submitError} />}

                  <Button
                    disabled={
                      submitting ||
                      (!showSetup && code.length < 6) ||
                      (showSetup && (code1.length < 6 || code2.length < 6))
                    }
                    type="submit"
                    size="full"
                    className="m-auto"
                  >
                    {showSetup ? 'Activar y acceder' : 'Verificar'}
                  </Button>

                  <div className="mt-6 text-center">
                    <button
                      type="button"
                      className="text-gray-500 hover:text-gray-700 text-sm underline"
                      onClick={handleCancel}
                    >
                      Cancelar
                    </button>
                  </div>
                </form>
              )}
            </Form>
            <SupportMessage />
          </div>
        </div>
      </div>
      <PublicFooter />
    </>
  )
}

export default TwoFactorVerify
